module.exports = __webpack_public_path__ + "static/img/page_22.599fa651.png";